<div class="rounded-2xl bg-white">
    <div
        class="flex-align-center relative flex justify-center rounded-2xl border-2 bg-white p-4 dark:border-contrast-yellow">
        <p class="font-semibold">{{ 'ANONYMOUS_PURCHASE_TITLE' | translate }}</p>
        <button
            class="!absolute right-4"
            [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
            (click)="cancel()"
            cdkFocusInitial
            mat-icon-button>
            <mat-icon class="vl-app-light:font-bold">close</mat-icon>
        </button>
    </div>
    <div class="content overflow-y-auto px-4 text-center">
        <p>{{ 'ANONYMOUS_PURCHASE_DESCRIPTION_0' | translate }}</p>
        <p class="mt-4">{{ 'ANONYMOUS_PURCHASE_DESCRIPTION_1' | translate }}</p>
    </div>
    <div class="p-4">
        <button
            class="btn--maximal link--no-line link--no-hover rounded-lg text-[var(--color-brand-primary)]"
            [attr.aria-label]="'STAY_LOGGED_OUT' | translate"
            (click)="login()">
            {{ 'STAY_LOGGED_OUT' | translate }}
        </button>
        <button
            class="btn--link btn btn--maximal btn--primary btn--big link--no-line link--no-hover mt-4 rounded-lg text-base font-bold normal-case"
            [attr.aria-label]="'USE_ACCOUNT' | translate"
            (click)="register()">
            {{ 'USE_ACCOUNT' | translate }}
        </button>
    </div>
</div>
